/**
 * CHADA Marketplace — main JS entry
 *
 * Bootstrap plugins are imported individually to keep the bundle small;
 * add more (Dropdown, Collapse, …) only as features need them.
 */

import 'bootstrap/js/dist/offcanvas'; // mobile drawer
import 'bootstrap/js/dist/dropdown';  // header nav dropdowns

import { initHeader } from './header.js';
import { initSearchOverlay } from './search-overlay.js';
import { initCopyButtons } from './copy.js';
import { initProductsArchive } from './products-archive.js';
import { initSearch } from './search.js';
import { initDocsToc } from './docs-toc.js';
import { initDocsHelpful } from './docs-helpful.js';
import { initSupportForm } from './support.js';
import { initBlogFilter } from './blog-filter.js';
import { initLegalToc } from './legal-toc.js';

document.documentElement.classList.add('chada-js');

initHeader();
initSearchOverlay();
initCopyButtons();
initProductsArchive();
initSearch();
initDocsToc();
initDocsHelpful();
initSupportForm();
initBlogFilter();
initLegalToc();
